<template>
  <div class="beijing" style="display: flex;">
    <nav class="leftmenu" :class="{ 'keyboard-open': isKeyboardOpen }">
        <div class="menu-header">
            <img :src="`${assetsUrl}/4yshop/img/logo.png`" alt="云语匀雨官方标志" class="logo-img">
            <span class="logo-text" @click="window.location.href='https://4yshop.top'">云语匀雨</span>
        </div>
        
        <div class="menu-list" ref="menuList">
            <!-- 滑动背景指示器 -->
            <div class="active-indicator" :style="indicatorStyle"></div>
            
            <li class="menu-item" @click="$router.push('/')">
                <router-link to="/" class="menu-link">
                    <i class="fa-solid fa-shop menu-icon"></i>
                    <span class="menu-text">推荐</span>
                </router-link>
            </li>
            <div class="glass-divider"></div>
            
            <li class="menu-item">
                <router-link to="/allapp" class="menu-link">
                    <i class="fa-solid fa-folder menu-icon"></i>
                    <span class="menu-text">全部</span>
                </router-link>
            </li>
            <div class="glass-divider"></div>
            
            <li class="menu-item">
                <router-link to="/fenlei" class="menu-link">
                    <i class="fa-solid fa-bookmark menu-icon"></i>
                    <span class="menu-text">分类</span>
                </router-link>
            </li>
            <div class="glass-divider"></div>
            
            <li class="menu-item">
                <router-link to="/article" class="menu-link">
                    <i class="fa-solid fa-file-lines menu-icon"></i>
                    <span class="menu-text">文章</span>
                </router-link>
            </li>
            <div class="glass-divider"></div>
            
            <!-- 聊天 -->
            <li class="menu-item chat-menu-item" v-if="isLoggedIn">
                <router-link to="/chat" class="menu-link chat-menu-link">
                    <i class="fa-solid fa-comment-dots menu-icon"></i>
                    <span class="menu-text">聊天</span>
                    <span v-if="unreadMsgCount > 0" class="nav-unread-badge">{{ unreadMsgCount > 99 ? '99+' : unreadMsgCount }}</span>
                </router-link>
            </li>
            <div class="glass-divider" v-if="isLoggedIn"></div>

            <!-- 频道 -->
            <li class="menu-item" v-if="isLoggedIn">
                <router-link to="/channel" class="menu-link">
                    <i class="fa-solid fa-comments menu-icon"></i>
                    <span class="menu-text">频道</span>
                </router-link>
            </li>
            <div class="glass-divider" v-if="isLoggedIn"></div>

            <li class="menu-item">
                <router-link to="/ranks" class="menu-link">
                    <i class="fa-solid fa-trophy menu-icon"></i>
                    <span class="menu-text">榜单</span>
                </router-link>
            </li>
            <div class="glass-divider"></div>

            <li class="menu-item">
                <router-link to="/fankui" class="menu-link">
                    <i class="fa-solid fa-envelope menu-icon"></i>
                    <span class="menu-text">反馈</span>
                </router-link>
            </li>
            <div class="glass-divider"></div>
            
            <li class="menu-item" @click="showAnnouncement">
                <a class="menu-link">
                    <i class="fa-solid fa-calendar menu-icon"></i>
                    <span class="menu-text">公告</span>
                </a>
            </li>
            <div class="glass-divider"></div>
            
            <li class="menu-item" @click="handleMyInfoClick">
                <a class="menu-link" :class="{ 'router-link-active': $route.path === '/myinfo' }">
                    <i class="fa-solid fa-user menu-icon"></i>
                    <span class="menu-text">我的</span>
                </a>
            </li>
        </div>
        
    </nav>
    <div class="neirong" style="flex: 1;">
        <router-view v-slot="{ Component, route }">
            <transition :name="getTransitionName(route)" mode="out-in">
                <component :is="Component" :key="route.path" />
            </transition>
        </router-view>
    </div>
    
</div>
</template>

<script>
import { assetsUrl } from '@/assets/BaseServerUrl.js'
import eventBus from '@/utils/eventBus'
import messagesService from '@/services/messagesService'

export default {
    components: {
    },
    data() {
        return {
            isLoggedIn: false,
            assetsUrl: assetsUrl,
            unreadMsgCount: 0,
            isKeyboardOpen: false,
            indicatorStyle: {
                top: '0px',
                left: '0px',
                width: '0px',
                height: '0px',
                opacity: 0,
                transition: 'all 0.45s cubic-bezier(0.23, 1, 0.32, 1)'
            }
        }
    },
    methods: {
        // 新增：更新滑动指示器位置（修复刷新后偏移问题）
        updateIndicator() {
            // 使用 requestAnimationFrame 确保在浏览器下一次重绘前执行
            // 并添加延迟确保 DOM 完全渲染和 CSS 动画完成
            this.$nextTick(() => {
                // 等待 Vue Router 更新 active 类名和 CSS 动画完成
                setTimeout(() => {
                    requestAnimationFrame(() => {
                        const activeLink = this.$el?.querySelector('.router-link-active');
                        if (activeLink) {
                            const menuItem = activeLink.closest('.menu-item');
                            if (menuItem) {
                                const isMobile = window.innerWidth <= 768;
                                
                                // 强制重新计算布局，确保获取最新的位置信息
                                void menuItem.offsetHeight;
                                
                                if (isMobile) {
                                    this.indicatorStyle = {
                                        top: '0px',
                                        left: `${menuItem.offsetLeft}px`,
                                        width: `${menuItem.offsetWidth}px`,
                                        height: '100%',
                                        opacity: 1,
                                        transition: 'all 0.45s cubic-bezier(0.23, 1, 0.32, 1)'
                                    };
                                } else {
                                    this.indicatorStyle = {
                                        top: `${menuItem.offsetTop}px`,
                                        left: '0px',
                                        width: '100%',
                                        height: `${menuItem.offsetHeight}px`,
                                        opacity: 1,
                                        transition: 'all 0.45s cubic-bezier(0.23, 1, 0.32, 1)'
                                    };
                                }
                                return;
                            }
                        }
                        // 如果没有找到激活的链接，隐藏指示器
                        this.indicatorStyle.opacity = 0;
                    });
                }, 100); // 延迟 100ms 确保动画完成
            });
        },
        checkLoginStatus() {
            const loginStatus = localStorage.getItem('isLoggedIn')
            const userData = localStorage.getItem('userInfo')
            this.isLoggedIn = (loginStatus === 'true' && !!userData)
            if (this.isLoggedIn) {
                this.loadUnreadCount()
            }
        },
        async loadUnreadCount() {
            try {
                const info = JSON.parse(localStorage.getItem('userInfo') || '{}')
                const uid = info.userId
                if (!uid) return
                const res = await messagesService.getUnreadCount(uid)
                if (res.success && res.data) {
                    this.unreadMsgCount = res.data.total || 0
                }
            } catch (e) { /* ignore */ }
        },
        getTransitionName(route) {
            if (route.path === '/') {
                return 'slide-vertical'
            } else if (route.path === '/allapp') {
                return 'slide-vertical'
            } else if (route.path.includes('/appdetails')) {
                return 'zoom-fade'
            } else {
                return 'slide-vertical'
            }
        },
        showAnnouncement() {
            eventBus.emit('show-announcement')
        },
        handleMyInfoClick() {
            const userInfo = localStorage.getItem('userInfo')
            if (userInfo) {
                this.$router.push('/myinfo')
            } else {
                this.$emit('show-login')
            }
        },
        onUnreadUpdate(data) {
            this.unreadMsgCount = data ? data.total : 0
        },
        // 新增：自动计算菜单项动画延迟，避免依赖 nth-child
        applyMenuDelays() {
            try {
                const root = this.$el && this.$el.querySelector ? this.$el : document
                const menuList = root.querySelector('.menu-list')
                if (!menuList) return
                const items = menuList.querySelectorAll('.menu-item')
                items.forEach((el, idx) => {
                    // 以 0.1s 递增的延迟，首项 0.1s
                    el.style.animationDelay = `${(idx + 1) * 0.1}s`
                })
            } catch (e) {
                console.warn('应用菜单动画延迟失败:', e)
            }
        }
    },
    mounted() {
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme === 'dark-theme') {
            document.body.classList.add('dark-theme');
        }
        this.checkLoginStatus()
        this.$nextTick(() => {
            this.applyMenuDelays();
            this.updateIndicator();
        })

        window.addEventListener('load', () => {
            this.updateIndicator();
        });

        window.addEventListener('storage', this.checkLoginStatus)
        window.addEventListener('resize', this.updateIndicator)
        eventBus.on('unread-messages-update', this.onUnreadUpdate)
        this.$router.afterEach(() => {
            this.checkLoginStatus()
            this.$nextTick(() => {
                this.applyMenuDelays();
                this.updateIndicator();
            })
        })

        if (window.visualViewport) {
            this._onVVR = () => {
                const vv = window.visualViewport
                if (window.innerWidth <= 768) {
                    this.isKeyboardOpen = vv.height < window.innerHeight * 0.75
                } else {
                    this.isKeyboardOpen = false
                }
            }
            window.visualViewport.addEventListener('resize', this._onVVR)
            window.visualViewport.addEventListener('scroll', this._onVVR)
        }
    },
    beforeUnmount() {
        window.removeEventListener('storage', this.checkLoginStatus)
        window.removeEventListener('resize', this.updateIndicator)
        eventBus.off('unread-messages-update', this.onUnreadUpdate)
        if (window.visualViewport && this._onVVR) {
            window.visualViewport.removeEventListener('resize', this._onVVR)
            window.visualViewport.removeEventListener('scroll', this._onVVR)
        }
    },
    // 新增：监听登录状态变化，变化后重应用延迟
    watch: {
        isLoggedIn() {
            this.$nextTick(() => this.applyMenuDelays())
        }
    }
}
</script>

<style lang="less">
.glass-divider{
    margin: 0px !important;;
}
.beijing {
    display: flex;
    background: rgba(255, 255, 255, 0.38); /* 轻微调深模拟 saturate 取代 backdrop-filter */
    will-change: transform;
    border-radius: 24px;
    margin: 0px 20px;
    margin-bottom: 20px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.06);
    /* 移除 transition: all 以避免 backdrop-filter 在过渡中闪烁 */
    transition: background 0.6s cubic-bezier(0.4, 0, 0.2, 1),
                border-color 0.6s cubic-bezier(0.4, 0, 0.2, 1),
                box-shadow 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 夜间模式下的主容器样式 */
body.dark-theme .beijing {
    background: rgba(30, 30, 30, 0.6);
    border-color: rgba(255, 255, 255, 0.1);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
}

.leftmenu {
    font-size: 25px;
    text-align: center;
    color: black !important;
    padding: 20px 10px;
    position: sticky;
    top: 0;
    align-self: flex-start;
    max-height: 100vh;
    overflow-y: auto;
    z-index: 100;
    transition: border-color 0.6s cubic-bezier(0.4, 0, 0.2, 1),
                color 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 左侧栏滚动条样式（桌面与大屏） */
.leftmenu::-webkit-scrollbar { width: 8px; }
.leftmenu::-webkit-scrollbar-thumb { background: rgba(0, 0, 0, 0.25); border-radius: 6px; }
.leftmenu::-webkit-scrollbar-track { background: rgba(0, 0, 0, 0.05); }
body.dark-theme .leftmenu::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.35); }

/* 夜间模式下的左侧菜单样式 */
body.dark-theme .leftmenu {
    border-right-color: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.9) !important;
}

// 路由动画效果
.neirong {
    overflow: hidden;
    border-left: 1px solid rgba(0, 0, 0, 0.05);
    min-width: 0;
}

// 上下滑动动画
.slide-vertical-enter-active, .slide-vertical-leave-active {
    transition: transform 0.6s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.slide-vertical-enter-from {
    transform: translateY(30px);
    opacity: 0;
}
.slide-vertical-leave-to {
    transform: translateY(-30px);
    opacity: 0;
}

// 从中间扩散渐变动画
.zoom-fade-enter-active, .zoom-fade-leave-active {
    transition: transform 0.8s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.8s cubic-bezier(0.23, 1, 0.32, 1);
    transform-origin: center center;
}
.zoom-fade-enter-from {
    transform: scale(0.8);
    opacity: 0;
}
.zoom-fade-leave-to {
    transform: scale(1.2);
    opacity: 0;
}

// 为所有路由组件添加定位
.neirong > * {
    width: 100%;
}

// 菜单头部样式
.menu-header {
    font-size: 16px;
    text-align: center;
    font-family: '爱点风雅黑';
    padding: 5px 15px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    animation: headerSlideIn 0.8s ease-out;
}

.logo-img {
    width: 30px;
    height: 30px;
    transition: transform 0.3s ease;
}

.logo-text {
    cursor: pointer;
    transition: color 0.3s ease;
}

.logo-text:hover {
    background: linear-gradient(135deg, #4CAF50 0%, #0071e3 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

/* 夜间模式下的logo文字样式 */
body.dark-theme .logo-text {
    color: rgba(255, 255, 255, 0.9);
}

body.dark-theme .logo-text:hover {
    color: #87ceeb;
}

.menu-header:hover .logo-img {
    transform: rotate(360deg) scale(1.1);
}

// 菜单列表容器
.menu-list {
    display: flex;
    flex-direction: column;
    gap: 5px;
    position: relative; /* 为指示器提供定位参考 */
}

/* 滑动指示器样式 */
.active-indicator {
    position: absolute;
    left: 0;
    width: 100%;
    background: rgba(0, 113, 227, 0.12);
    border-radius: 20px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    will-change: top, height;
    z-index: 0; /* 置于 menu-item 下层 */
    box-shadow: 0 4px 12px rgba(0, 113, 227, 0.08);
}

body.dark-theme .active-indicator {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow: none;
}

// 菜单项基础样式
.menu-item {
    list-style: none;
    border-radius: 20px;
    margin: 5px 0;
    position: relative;
    z-index: 1; /* 保证在滑动背景层之上 */
    overflow: hidden;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.menu-link {
    font-family: '爱点风雅黑';
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 20px;
    text-decoration: none;
    color: inherit;
    position: relative;
    z-index: 2;
    transition: transform 0.3s ease, color 0.3s ease;
}

/* router-link 特定样式 - 移除背景，由指示器承载 */
.menu-link.router-link-active {
    color: #0071e3; /* 文字使用蓝色 */
    font-weight: 600;
}

.menu-link.router-link-active .menu-icon {
    color: #0071e3;
    transform: scale(1.1);
}

/* 夜间模式下的激活状态样式 */
body.dark-theme .menu-link.router-link-active {
    color: #87ceeb;
}

body.dark-theme .menu-link.router-link-active .menu-icon {
    color: #87ceeb;
}

.menu-icon {
    margin-right: 8px;
    transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    font-size: 1.1em;
}

.menu-text {
    transition: all 0.3s ease;
    font-weight: 500;
}

// 菜单项悬停效果
.menu-item:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateX(8px) scale(1.02);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.05);
}

.menu-item:hover .menu-icon {
    transform: scale(1.3) rotate(10deg);
    color: #4CAF50;
}

.menu-item:hover .menu-text {
    color: #4CAF50;
    font-weight: 600;
}

/* 夜间模式下的菜单项样式 */
body.dark-theme .menu-item:hover {
    background: linear-gradient(135deg, rgba(135, 206, 235, 0.15) 0%, rgba(100, 149, 237, 0.15) 100%);
}

body.dark-theme .menu-item:hover .menu-icon {
    color: #87ceeb;
}

body.dark-theme .menu-item:hover .menu-text {
    color: #4CAF50;
}

// 菜单项点击效果
.menu-item:active {
    transform: translateX(3px) scale(0.98);
    transition: transform 0.1s ease;
}

// "我的"菜单项特殊效果
.special-item {
    background: linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%);
    border: 2px solid rgba(255, 193, 7, 0.3);
    animation: specialGlow 2s ease-in-out infinite alternate;
}

.special-item:hover {
    background: linear-gradient(135deg, rgba(255, 193, 7, 0.2) 0%, rgba(255, 152, 0, 0.2) 100%);
    border-color: rgba(255, 193, 7, 0.6);
    transform: translateX(8px) scale(1.05);
    box-shadow: 0 12px 35px rgba(255, 193, 7, 0.4);
}

.special-item:hover .menu-icon {
    color: #ffc107;
    transform: scale(1.4) rotate(15deg);
    text-shadow: 0 0 10px rgba(255, 193, 7, 0.5);
}

.special-item:hover .menu-text {
    color: #ffc107;
    font-weight: 700;
    text-shadow: 0 0 8px rgba(255, 193, 7, 0.3);
}

.special-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    transition: left 0.5s ease;
    z-index: 1;
}

.special-item:hover::before {
    left: 100%;
}

.leftmenu p.divider {
    padding: 0px 30px;
}



.leftmenu p.divider {
    margin: 0px;
    font-family: '猫啃网糖圆体';
}



.neirong {
    flex: 1;
}

.article-container {
    display: none;
}

.nav-unread-badge {
    position: absolute;
    top: 2px;
    right: 2px;
    min-width: 18px;
    height: 18px;
    line-height: 18px;
    padding: 0 5px;
    font-size: 10px;
    font-weight: 700;
    color: #fff;
    background: rgba(220, 50, 50, 0.75);
    border-radius: 9px;
    text-align: center;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    z-index: 10;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.15);
}

body.dark-theme .nav-unread-badge {
    background: rgba(255, 80, 80, 0.55);
    border-color: rgba(255, 255, 255, 0.1);
}

.chat-menu-link {
    position: relative;
}

@media (max-width: 768px) {
    .nav-unread-badge {
        top: -4px;
        right: 50%;
        transform: translateX(calc(50% + 16px));
        min-width: 14px;
        height: 14px;
        line-height: 14px;
        padding: 0 3px;
        font-size: 8px;
    }
}

.chat-menu-item {
    overflow: visible !important;
}

.zhujiemian {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
}

.search {
    width: 100%;
}

.fankui {
    width: 100%;
}

// 移除transition-group相关的进入动画，保持其他动画效果

// 为每个菜单项添加延迟进入效果
.menu-item:nth-child(1) { animation-delay: 0.1s; }
.menu-item:nth-child(3) { animation-delay: 0.2s; }
.menu-item:nth-child(5) { animation-delay: 0.3s; }
.menu-item:nth-child(7) { animation-delay: 0.4s; }
.menu-item:nth-child(9) { animation-delay: 0.5s; }
.menu-item:nth-child(11) { animation-delay: 0.6s; }
.menu-item:nth-child(13) { animation-delay: 0.7s; }
.menu-item:nth-child(15) { animation-delay: 0.8s; }
// 新增：当登录状态显示“好友/聊天”时，后续项也按序延迟
.menu-item:nth-child(17) { animation-delay: 0.9s; }
.menu-item:nth-child(19) { animation-delay: 1.0s; }

// 关键帧动画定义
@keyframes headerSlideIn {
    0% {
        opacity: 0;
        transform: translateY(-20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes specialGlow {
    0% {
        box-shadow: 0 0 5px rgba(255, 193, 7, 0.3);
    }
    100% {
        box-shadow: 0 0 20px rgba(255, 193, 7, 0.6), 0 0 30px rgba(255, 193, 7, 0.4);
    }
}

// 菜单项初始动画
@keyframes menuItemSlideIn {
    0% {
        opacity: 0;
        transform: translateX(-30px) scale(0.8);
    }
    100% {
        opacity: 1;
        transform: translateX(0) scale(1);
    }
}

.menu-item {
    animation: menuItemSlideIn 0.6s cubic-bezier(0.25, 0.8, 0.25, 1) both;
}

// 移动端适配媒体查询
@media (max-width: 768px) {
    .beijing {
        margin: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        border: none !important;
        backdrop-filter: none !important;
        -webkit-backdrop-filter: none !important;
        box-shadow: none !important;
        display: block !important;
        will-change: auto !important; /* 解除 containing block，保证子元素 fixed 相对视口绝对定位 */
    }

    .leftmenu {
        position: fixed !important;
        top: auto !important;
        bottom: 20px !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        width: 90% !important;
        height: auto !important;
        border-radius: 24px !important; /* 大圆角 */
        border: 1px solid rgba(255, 255, 255, 0.4) !important;
        background: rgba(255, 255, 255, 0.65) !important;
        backdrop-filter: blur(15px) saturate(180%) !important;
        -webkit-backdrop-filter: blur(15px) saturate(180%) !important;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
        z-index: var(--z-modal) !important;
        padding: 6px 10px !important;
        font-size: 20px;
        overflow: visible !important;
    }
    .neirong {
        border-left: none !important;
        padding: 0 !important;
        padding-bottom: 100px !important; /* 给底部的悬浮导航栏留出足够空间 */
        flex: 1 !important;
        height: auto !important;
        overflow-y: visible !important;
    }

    /* 隐藏导航头部的图标与“云语匀雨”四个字 */
    .menu-header, .logo-text, .logo-img { display: none !important; }
    
    .menu-list {
        display: flex !important;
        flex-direction: row !important;
        justify-content: space-around !important;
        align-items: center !important;
        gap: 0 !important;
        padding: 0 10px !important;
        flex-wrap: nowrap !important;
        overflow: visible !important;
    }
    
    /* 移动端启用指示器但调整样式 */
    .active-indicator {
        display: block !important;
        background: rgba(0, 113, 227, 0.08) !important;
        border: none !important;
        border-radius: 12px !important;
        box-shadow: none !important;
    }
    
    .menu-item {
        flex: 1;
        max-width: none;
        box-sizing: border-box;
        margin: 0;
        border-radius: 16px;
        transition: all 0.3s ease;
    }
    
    .menu-item:active {
        background: rgba(0, 0, 0, 0.05); /* 点击反馈 */
        transform: scale(0.92);
    }
    
    .menu-link {
        flex-direction: column;
        padding: 5px 0; /* 再次减小间距 */
        gap: 2px; /* 减小图标与文字间距 */
    }
    
    .menu-icon {
        color: #555;
        margin-right: 0;
        margin-bottom: 0;
        font-size: 1.05em; /* 再次减小图标大小 */
        transition: all 0.3s ease;
    }
    
    /* 移动端恢复显示文字，调整为更小号字体 */
    .menu-text { 
        display: block !important; 
        font-size: 8px !important; /* 再次减小文字大小 */
        font-weight: 500;
        color: #666;
    }
    
    /* 激活状态：图标放大、颜色高亮，背景微亮 */
    /* 激活状态：移除静态背景，由 indicator 承载 */
    .menu-link.router-link-active { 
        background: transparent !important; 
        border: none;
        box-shadow: none;
    }
    .menu-link.router-link-active .menu-icon { 
        color: #0071e3; 
        transform: translateY(-1px) scale(1.05); 
    }
    .menu-link.router-link-active .menu-text {
        color: #0071e3;
        font-weight: 700;
    }
    
    /* 夜间模式移动端适配 */
    body.dark-theme .leftmenu {
        background: rgba(30, 30, 30, 0.75) !important;
        border: 1px solid rgba(255, 255, 255, 0.15) !important;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5) !important;
    }
    
    body.dark-theme .menu-item:active {
        background: rgba(255, 255, 255, 0.08);
    }
    
    body.dark-theme .menu-icon,
    body.dark-theme .menu-text {
        color: rgba(255, 255, 255, 0.6);
    }
    
    /* 深色模式下的点击和激活态 */
    body.dark-theme .menu-link.router-link-active {
        background: transparent !important;
    }
    body.dark-theme .active-indicator {
        background: rgba(255, 255, 255, 0.12) !important;
    }
    body.dark-theme .menu-link.router-link-active .menu-icon,
    body.dark-theme .menu-link.router-link-active .menu-text {
        color: #87ceeb !important; /* 夜间模式主题蓝 */
    }
    
    .glass-divider { display: none !important; }
    
    .leftmenu.keyboard-open {
        transform: translateX(-50%) translateY(150%) !important;
    }
    
}

@media (max-width: 480px) {
    .leftmenu { 
        bottom: 15px !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        width: 94% !important;
        padding: 4px 6px !important; 
    }
    .menu-list { padding: 0 4px !important; }
    .menu-link { padding: 6px 0; gap: 3px; }
    .menu-icon { font-size: 1.15em; }
    .menu-text { font-size: 10px !important; }
}
</style>